import Axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import IdentityManagerFactory from '../identity/IdentityManagerFactory';
import store from '../../../redux/store';
import cfgGetter from '../../utility/cfgGetter';

class httpService {
  instance: AxiosInstance;
  getStore: any;
  controller: AbortController;

  constructor() {
    this.instance = Axios;
    this.initiateInterceptor();
    this.getStore = store.getState;
    this.controller = new AbortController();
  }

  getEndpointURL(endpoint) {
    let baseUrl = cfgGetter();
    return baseUrl + endpoint;
  }

  initiateInterceptor() {
    this.instance.interceptors.request.use(
      async (req) => {
        try {
          if (this.getStore().impersonate.impersonate) {
            if (req.url.includes('?')) {
              req.url = req.url + `&impersonate=${this.getStore().impersonate.impersonateId}`;
            } else {
              req.url = req.url + `?impersonate=${this.getStore().impersonate.impersonateId}`;
            }
          }
          const token = await IdentityManagerFactory.getManager().accessToken();
          req.headers['Authorization'] = `Bearer ${token}`;
          return req;
        } catch (err) {
          console.error('interceptor err', err);
          return req;
        }
      },
      (err) => {
        return Promise.reject(err);
      }
    );
  }

  post(endpoint, body = null, config = {}) {
    return this.instance.post(endpoint, body, config);
  }

  get(endpoint, config = {}) {
    config['signal'] = this.controller.signal;

    return this.instance.get(endpoint, config);
  }

  put(endpoint, data = null, config = {}) {
    return this.instance.put(endpoint, data, config);
  }

  delete(endpoint, config = {}) {
    return this.instance.delete(endpoint, config);
  }

  getTyped<Type>(endpoint: string, config: AxiosRequestConfig = {}) {
    return this.instance
      .get<Type>(endpoint, { ...{ signal: this.controller.signal }, ...config })
      .then((response: AxiosResponse<Type>) => response.data);
  }
}

let instance = new httpService();

export default instance;
